export const APPLICATION_JSON = 'application/json';
export const FORM_DATA = 'multipart/form-data';